import { Component, OnInit, Input } from '@angular/core';

import { EmbedVideoService } from 'ngx-embed-video';

@Component({
  selector: 'app-embedded-video',
  template: `
    <div [innerHtml]="iframeHtml">
    </div>
  `,
  styleUrls: ['./embedded-video.component.scss']
})
export class EmbeddedVideoComponent implements OnInit {
  @Input() videoUrl: string;
  @Input() query: any;
  @Input() attr: any;

  iframeHtml: any;
  thumbnail: any;

  constructor(private embedSvc: EmbedVideoService) { }

  ngOnInit() {
    let options;

    if (this.query) {
      options = {
        query: this.query
      };
    }

    if (this.attr) {
      options ? options.attr = this.attr : options = { attr: this.attr }
    }

    this.iframeHtml = this.embedSvc.embed(this.videoUrl, options)
  }
}
